// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageWrapper_wrapper___AbTj","pwa":"PageWrapper_pwa__p1YaI","waveAnimation":"PageWrapper_waveAnimation__BGuRt","marquee":"PageWrapper_marquee__Vib0c"};